"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledTableContainer = styled_components_1.default.div `
  border: 1px solid ${config_1.colors.huron};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(22, 21, 29, 0.1);
  height: auto;
  margin: ${(props) => (props.margin ? props.margin : '0')};
  width: 100%;
`;
